import {ISurveyResult} from "./ISurveyResult";
export class ISurveyResultSubQuestion {
  id:number;
  title:string;
  question_type_id:number;
  __options:Array<ISurveyResult>;
}
